// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-container {
  position: relative;
}

.input-container .clear-btn {
  position: absolute;
  top: 50%;
  inset-inline-end: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
  color: #6c757d;
  background-color: #f8f9fa;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10;
}

.input-container .clear-btn:hover {
  color: #dc3545;
  background-color: #e9ecef;
  transform: translateY(-50%) scale(1.1);
}

::ng-deep .timepicker-disabled {
  pointer-events: none;
  opacity: 0.6;
}
::ng-deep .timepicker-disabled .mat-mdc-form-field-icon-suffix {
  display: none !important;
}
::ng-deep .timepicker-disabled mat-icon[matsuffix] {
  display: none !important;
}
::ng-deep .timepicker-disabled .mat-mdc-form-field-flex {
  pointer-events: none;
}
::ng-deep .timepicker-disabled .mat-mdc-input-element {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/datepicker/datepicker.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEE;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;EACA,sCAAA;AACF;;AAGA;EACE,oBAAA;EACA,YAAA;AAAF;AAGE;EACE,wBAAA;AADJ;AAKE;EACE,wBAAA;AAHJ;AAOE;EACE,oBAAA;AALJ;AASE;EACE,oBAAA;AAPJ","sourcesContent":[".input-container {\n    position: relative;\n  }\n  \n  .input-container .clear-btn {\n  position: absolute;\n  top: 50%;\n  inset-inline-end: 10px;\n  transform: translateY(-50%);\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 18px;\n  color: #6c757d;\n  background-color: #f8f9fa;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  z-index: 10;\n}\n\n.input-container .clear-btn:hover {\n  color: #dc3545;\n  background-color: #e9ecef;\n  transform: translateY(-50%) scale(1.1);\n}\n\n// Hide timepicker icon/button when disabled\n::ng-deep .timepicker-disabled {\n  pointer-events: none;\n  opacity: 0.6;\n  \n  // Hide the icon that opens the picker (MDC Material Design)\n  .mat-mdc-form-field-icon-suffix {\n    display: none !important;\n  }\n  \n  // Also hide the icon directly\n  mat-icon[matsuffix] {\n    display: none !important;\n  }\n  \n  // Hide any clickable elements in the form field\n  .mat-mdc-form-field-flex {\n    pointer-events: none;\n  }\n  \n  // Prevent clicking on the input field\n  .mat-mdc-input-element {\n    pointer-events: none;\n    // cursor: not-allowed;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
